import { useCallback, useEffect, useState } from "react";
import { platformService } from "../../../api/platform.service.js";
import { useQuery } from "../../../hooks/useApi.js";
import { SLOT_FLAG_SCOPE, flagKeysTargetingSlot } from "./slotTargetedFlags.js";

export const SLOT_FLAGS_POLL_INTERVAL = 5000;

export type SlotTargetedFlags = {
  flagKeys: string[];
  loading: boolean;
  error: Error | null;
};

export function useSlotTargetedFlags() {
  const { data, error, refetch } = useQuery(
    () => platformService.getFeatureFlags({ scope: SLOT_FLAG_SCOPE }),
    [],
  );
  const [lastError, setLastError] = useState<Error | null>(null);

  useEffect(() => {
    if (error) setLastError(error);
  }, [error]);

  useEffect(() => {
    if (data) setLastError(null);
  }, [data]);

  useEffect(() => {
    const interval = setInterval(() => void refetch(), SLOT_FLAGS_POLL_INTERVAL);
    return () => clearInterval(interval);
  }, [refetch]);

  const currentError = error ?? lastError;
  const loading = data === null && currentError === null;

  const flagsFor = useCallback(
    (slot: string): SlotTargetedFlags => ({
      flagKeys: currentError ? [] : flagKeysTargetingSlot(data?.featureFlags ?? [], slot),
      loading,
      error: currentError,
    }),
    [data, loading, currentError],
  );

  return { flagsFor, error: currentError, refetch };
}
